import React, { useMemo, useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  useTheme,
  CircularProgress,
  Box,
  Card,
  Button,
  useMediaQuery,
  Paper,
  FormControlLabel,
  Checkbox,
  DialogTitle,
  InputAdornment,
  FormGroup,
  ToggleButtonGroup,
  ToggleButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Autocomplete,
  Backdrop,
  Dialog,
  DialogContent,
  MenuItem,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { FormikProvider, useFormik } from "formik";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import {
  useUpdateDynamicScheduleMutation,
  useCreateRequestMutation,
  useGetTeamSerchOnlyQuery,
  useGetEmployeeScheduleDetailsByDateOnlyEmploeeQuery,
  useGetEmailTemplatesQuery,
  useGetTeamQuery,
} from "../../../Api/attoDeskApi";
import CloseIcon from "@mui/icons-material/Close";
import {
  ITeam,
  Schedule,
  IScheduleListDetails,
  IEmailTemplet,
  EmailTemplateOption,
} from "../../../Api/Interface/api.interface";
import { Link, useNavigate } from "react-router-dom";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import useIsMobile from "../../../Core/hook/useIsMobile";
import "react-quill/dist/quill.snow.css";
import { Privileges, widthofReactQuill } from "../../../Core/Enum/enum";
import TimeDropdown from "../../../Components/CustomTimePicker/TimeDropdown";
import useUser from "../../../Core/hook/useUser";
import { capitalizeFirstLetter } from "../../../Components/Validation/capitalizeFirstLetter";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import DeleteIcon from "@mui/icons-material/Delete";

interface ITeampopup {
  openModel?: boolean;
  handleCloseDialog: (close: boolean) => void;
  scheduleDate: String;
  requestData: IScheduleListDetails;
}

type FormValues = {
  id: string;
  empid: string;
  startTime: string;
  endTime: string;
  date: Dayjs;
  isUpdateForAllDate: boolean;
  isReSchedules: boolean;
  spansNextDay: boolean;
  isRemovedSchedule: boolean;
  isEditedSchedule: boolean;
  isCreateSchedule: boolean;
};

type FormValuesRequest = {
  startTime: string;
  endTime: string;
  schedule_date: Dayjs;
  spansNextDay: boolean;
  message: string;
  smsReminder: boolean;
  emailReminder: boolean;
  respondents_total: number | null;
  reason: string;
  subject: string;
};

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const Team = ({
  openModel = false,
  handleCloseDialog,
  scheduleDate,
  requestData,
}: ITeampopup) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobileRes = useIsMobile();
  const { userHasRight } = useUser();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);

  const [open] = React.useState(openModel);
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [mode, setMode] = React.useState<"schedule">("schedule");
  const [searchQueryCustomer, setSearchQueryCustomer] = useState<string>("");
  const [selectedOption, setSelectedOption] =
    useState<EmailTemplateOption | null>(null);
  const [currentSearchQueryCustomer, setCurrentSearchQueryCustomer] =
    useState<string>("");
  const debouncedSearchQueryCustomer = useDebounce(searchQueryCustomer, 300);
  const [showDropdownCustomer, setShowDropdownCustomer] =
    useState<boolean>(false);

  const [openRemovePopup, setOpenRemovePopup] = useState<boolean>(false);

  const [selectedCoursingResche, setSelectedCoursingResche] =
    useState<IScheduleListDetails | null>(null);

  const handleClose = () => {
    handleCloseDialog(false);
  };

  const [newCompany, { isLoading }] = useUpdateDynamicScheduleMutation();

  const [newRequest, { isLoading: requestIsLoading }] =
    useCreateRequestMutation();

  const {
    data: tenantData,
    isLoading: tenantIsLoading,
    isError,
    refetch,
  } = useGetTeamSerchOnlyQuery({
    searchText: searchQueryCustomer,
    id: "",
  });

  const { data: userroleData, isLoading: userroleIsLoading } =
    useGetEmailTemplatesQuery({
      searchText: "",
    });

  const { data: staffGetAllData, isLoading: staffGetAllIsLoading } =
    useGetTeamQuery({
      searchText: "",
      id: "",
    });

  const userroleList = useMemo(() => {
    return userroleData?.data as IEmailTemplet[];
  }, [userroleData?.data]);

  const userRoleOptions: EmailTemplateOption[] = useMemo(() => {
    if (!Array.isArray(userroleList)) return [];
    return userroleList.map((cust) => ({
      label: toProperCase(cust.template_name),
      value: cust.id,
      subject: cust.subject,
      message: cust.message,
      attachments: cust.attachments,
    }));
  }, [userroleList]);

  const teamList: ITeam[] = Array.isArray(tenantData?.data)
    ? (tenantData?.data as ITeam[])
    : [];

  const teamAllList: ITeam[] = Array.isArray(staffGetAllData?.data)
    ? (staffGetAllData?.data as ITeam[])
    : [];

  const teamMap = useMemo(() => {
    const map = new Map<
      number,
      {
        name: string;
        image: string;
        hourlySalary: string;
        otHourlySalary: string;
      }
    >();

    teamAllList?.forEach((teamMember) => {
      const fullName = `${capitalizeFirstLetter(
        teamMember.teamFirstName || ""
      )} ${capitalizeFirstLetter(teamMember.teamLastName || "")}`.trim();

      map.set(teamMember.id, {
        name: fullName,
        image: teamMember.teamImg,
        hourlySalary: teamMember.teamHourlySalary,
        otHourlySalary: teamMember.teamOtHourlySalary,
      });
    });

    return map;
  }, [teamList]);

  const formik = useFormik<FormValues>({
    initialValues: {
      id: requestData?.schedule?.id ? String(requestData.schedule.id) : "",
      empid: requestData?.schedule?.empid
        ? String(requestData.schedule.empid)
        : "",
      startTime: requestData?.schedule?.startTime || "",
      endTime: requestData?.schedule?.endTime || "",
      date: dayjs(scheduleDate.toString()),
      spansNextDay: requestData?.schedule?.spansNextDay
        ? Boolean(requestData.schedule.spansNextDay)
        : false,
      isUpdateForAllDate: false,
      isReSchedules: requestData.isReSchedules,
      isRemovedSchedule: false,
      isEditedSchedule: true,
      isCreateSchedule: false,
    },
    enableReinitialize: true,
    validate: (values) => {
      const errors: Partial<Record<keyof FormValues, string>> = {};

      const isValidTime = (t: string) => /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(t);

      const toMinutes = (time: string, spansNextDay: boolean = false) => {
        const [h, m] = time.split(":").map(Number);
        let total = h * 60 + m;
        return spansNextDay ? total + 24 * 60 : total;
      };

      if (!values.startTime || !isValidTime(values.startTime)) {
        errors.startTime = "Start time is required (HH:mm)";
      }

      if (!values.endTime || !isValidTime(values.endTime)) {
        errors.endTime = "End time is required (HH:mm)";
      }

      if (
        values.startTime &&
        values.endTime &&
        isValidTime(values.startTime) &&
        isValidTime(values.endTime)
      ) {
        const startMin = toMinutes(values.startTime);
        const endMin = toMinutes(values.endTime, values.spansNextDay);

        if (endMin <= startMin) {
          errors.endTime = "End time must be after start time";
        }
      }

      return errors;
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const updatedData: {
          id?: string;
          empid: string;
          date: string;
          startTime: string;
          endTime: string;
          isUpdateForAllDate: boolean;
          isReSchedules: boolean;
          spansNextDay: boolean;
          isRemovedSchedule: boolean;
          isEditedSchedule: boolean;
          isCreateSchedule: boolean;
        } = {
          id: values.id,
          empid: values.empid,
          date: values.date.format("YYYY-MM-DD"),
          startTime: values.startTime,
          endTime: values.endTime,
          isUpdateForAllDate: values.isUpdateForAllDate,
          isReSchedules: values.isReSchedules,
          spansNextDay: values.spansNextDay,

          isRemovedSchedule: values.isRemovedSchedule,
          isEditedSchedule: values.isEditedSchedule,
          isCreateSchedule: values.isCreateSchedule,
        };

        // if (!data.isReSchedules) {
        //   delete updatedData.id;
        // }

        const response = await newCompany(updatedData).unwrap();
        if (!response.status) {
          showErrorMessage(response.message);
        } else {
          showMessage(response.message);
          rescheduleRefetch();
          resetForm();
          setSearchQueryCustomer("");
          const newValues = {
            id: "",
            empid: "",
            startTime: "",
            endTime: "",
            date: dayjs(scheduleDate.toString()),
            isUpdateForAllDate: false,
            isReSchedules: false,
            spansNextDay: false,
            isRemovedSchedule: false,
            isEditedSchedule: false,
            isCreateSchedule: true,
          };
          formik.setValues(newValues);
          setOpenRemovePopup(false);
          handleClose();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  useEffect(() => {
    if (requestData?.schedule?.empid) {
      setSearchQueryCustomer(
        teamMap.get(requestData?.schedule?.empid)?.name || ""
      );
      formik.setFieldValue("empid", String(requestData.schedule.empid));
      // formik.setFieldValue("id", String(requestData.schedule.id));
      // formik.setFieldValue("startTime", String(requestData.schedule.startTime));
      // formik.setFieldValue("endTime", String(requestData.schedule.endTime));
      // formik.setFieldValue(
      //   "spansNextDay",
      //   String(requestData.schedule.spansNextDay)
      // );
      // formik.setFieldValue("isUpdateForAllDate", false);
      // formik.setFieldValue("isReSchedules", Boolean(requestData.isReSchedules));
      // formik.setFieldValue("isRemovedSchedule", false);
      // formik.setFieldValue("isEditedSchedule", true);
      // formik.setFieldValue("isCreateSchedule", false);

      
      setOpenRemovePopup(false);
    }
  }, [requestData]);

  const formikRequest = useFormik<FormValuesRequest>({
    initialValues: {
      startTime: requestData?.schedule?.startTime || "",
      endTime: requestData?.schedule?.endTime || "",
      spansNextDay: requestData?.schedule?.spansNextDay
        ? Boolean(requestData.schedule.spansNextDay)
        : false,
      schedule_date: dayjs(scheduleDate.toString()),
      message: "",
      emailReminder: true,
      smsReminder: false,
      respondents_total: null,
      reason: "",
      subject: "",
    },
    validate: (values) => {
      const errors: Partial<Record<keyof FormValues, string>> = {};

      const isValidTime = (t: string) => /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(t);

      const toMinutes = (time: string, spansNextDay: boolean = false) => {
        const [h, m] = time.split(":").map(Number);
        let total = h * 60 + m;
        return spansNextDay ? total + 24 * 60 : total;
      };

      if (!values.startTime || !isValidTime(values.startTime)) {
        errors.startTime = "Start time is required (HH:mm)";
      }

      if (!values.endTime || !isValidTime(values.endTime)) {
        errors.endTime = "End time is required (HH:mm)";
      }

      if (
        values.startTime &&
        values.endTime &&
        isValidTime(values.startTime) &&
        isValidTime(values.endTime)
      ) {
        const startMin = toMinutes(values.startTime);
        const endMin = toMinutes(values.endTime, values.spansNextDay);

        if (endMin <= startMin) {
          errors.endTime = "End time must be after start time";
        }
      }

      return errors;
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        // Mark id as optional in the type definition
        const updatedData: {
          schedule_date: string;
          startTime: string;
          endTime: string;
          spansNextDay: boolean;
          message: string;
          smsReminder: boolean;
          emailReminder: boolean;
          respondents_total: number | null;
          reason: string;
          subject: string;
        } = {
          schedule_date: values.schedule_date.format("YYYY-MM-DD"),
          startTime: values.startTime,
          endTime: values.endTime,
          spansNextDay: values.spansNextDay,
          message: values.message,
          emailReminder: values.emailReminder,
          smsReminder: values.smsReminder,
          respondents_total: values.respondents_total,
          reason: values.reason,
          subject: values.subject,
        };

        const response = await newRequest(updatedData).unwrap();
        if (!response.status) {
          showErrorMessage(response.message);
        } else {
          showMessage(response.message);
          handleClose();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const {
    data,
    isLoading: rescheduleIsLoading,
    isError: rescheduleIsError,
    refetch: rescheduleRefetch,
  } = useGetEmployeeScheduleDetailsByDateOnlyEmploeeQuery({
    date: dayjs(scheduleDate.toString()).format("YYYY-MM-DD"),
    empid: String(formik.values.empid),
  });

  const formValid = useMemo(() => {
    return formik.values.empid === "" ||
      formik.values.startTime === "" ||
      formik.values.endTime === "" ||
      !formik.values.date ||
      !dayjs(formik.values.date).isValid()
      ? false
      : true;
  }, [formik.values]);

  const formValidRequest = useMemo(() => {
    const {
      startTime,
      endTime,
      message,
      respondents_total,
      emailReminder,
      smsReminder,
      schedule_date,
      subject,
    } = formikRequest.values;

    const hasAtLeastOneReminder = emailReminder || smsReminder;

    return !(
      startTime === "" ||
      endTime === "" ||
      message === "" ||
      subject === "" ||
      respondents_total === null ||
      respondents_total === 0 ||
      !hasAtLeastOneReminder ||
      !schedule_date ||
      !dayjs(schedule_date).isValid()
    );
  }, [formikRequest.values]);

  const handleAutocompleteChange = (
    event: React.SyntheticEvent,
    newValue: EmailTemplateOption | null
  ) => {
    setSelectedOption(newValue);

    if (newValue) {
      formikRequest.setFieldValue("subject", newValue.subject || "");
      formikRequest.setFieldValue("message", newValue.message || "");
      // formikRequest.setFieldValue("attachments", newValue.attachments || []);
    } else {
      formikRequest.setFieldValue("subject", "");
      formikRequest.setFieldValue("message", "");
      // formikRequest.setFieldValue("attachments", []);
    }
  };

  const handleRemoveSetSchedule = (data: IScheduleListDetails) => {
    const newValues = {
      ...formik.values,
      id: data?.schedule?.id ? String(data.schedule.id) : "",
      empid: data?.schedule?.empid ? String(data.schedule.empid) : "",
      startTime: data?.schedule?.startTime || "",
      endTime: data?.schedule?.endTime || "",
      hourlySalary: data?.schedule?.hourlySalary
        ? String(data.schedule.hourlySalary)
        : "",
      spansNextDay: data?.schedule?.spansNextDay
        ? Boolean(data.schedule.spansNextDay)
        : false,

      isUpdateForAllDate: false,
      isReSchedules: data.isReSchedules,
      isRemovedSchedule: true,
      isEditedSchedule: false,
      isCreateSchedule: false,
    };

    formik.setValues(newValues);
    setOpenRemovePopup(true);
  };

  const handleCloseRemovedSetSchedule = () => {
    const newValues = {
      ...formik.values,
      id: "",
      startTime: "",
      endTime: "",
      isUpdateForAllDate: false,
      isReSchedules: false,
      spansNextDay: false,
      isRemovedSchedule: false,
      isEditedSchedule: false,
      isCreateSchedule: true,
    };
    formik.setValues(newValues);
    setOpenRemovePopup(false);
  };
  
  const handleEditedSchedule = (data: IScheduleListDetails) => {
    const newValues = {
      ...formik.values,
      id: data?.schedule?.id ? String(data.schedule.id) : "",
      empid: data?.schedule?.empid ? String(data.schedule.empid) : "",
      startTime: data?.schedule?.startTime || "",
      endTime: data?.schedule?.endTime || "",
      hourlySalary: data?.schedule?.hourlySalary
        ? String(data.schedule.hourlySalary)
        : "",
      spansNextDay: data?.schedule?.spansNextDay
        ? Boolean(data.schedule.spansNextDay)
        : false,

      isUpdateForAllDate: false,
      isReSchedules: data.isReSchedules,
      isRemovedSchedule: false,
      isEditedSchedule: true,
      isCreateSchedule: false,
    };

    formik.setValues(newValues);
  };

  const getButtonLabel = () => {
    if (formik.values.isRemovedSchedule) return "Remove Schedule";
    if (formik.values.isEditedSchedule) return "Update Schedule";
    if (
      formik.values.isCreateSchedule &&
      formik.values.isUpdateForAllDate &&
      !formik.values.id &&
      !formik.values.isEditedSchedule &&
      !formik.values.isEditedSchedule
    )
      return "Create Schedule";
    if (
      formik.values.isCreateSchedule &&
      !formik.values.isUpdateForAllDate &&
      !formik.values.id &&
      !formik.values.isEditedSchedule &&
      !formik.values.isEditedSchedule
    )
      return "Create Reschedule";
    return "Create Reschedule";
  };

  const coursings: IScheduleListDetails[] = Array.isArray(data?.data)
    ? (data?.data as IScheduleListDetails[])
    : [];

  const handleTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQueryCustomer(value);
    if (!value.trim()) {
      formik.setFieldValue("empid", "");
    }
  };

  const handleFocusOrClickCustomer = () => {
    setShowDropdownCustomer(true);
    if (currentSearchQueryCustomer === "") {
      refetch();
    }
  };

  const handleSelectCustomer = (team: ITeam) => {
    formik.setFieldValue("empid", team.id);
    setSearchQueryCustomer(
      `${team.teamFirstName || ""} ${team.teamLastName || ""}`
    );
    setShowDropdownCustomer(false);
  };

  useEffect(() => {
    if (userRoleOptions.length > 0 && !selectedOption) {
      const defaultTemplate = userRoleOptions.find(
        (option) => option.value == "7"
      );

      if (defaultTemplate) {
        setSelectedOption(defaultTemplate);
        formikRequest.setFieldValue("subject", defaultTemplate.subject);
        formikRequest.setFieldValue("message", defaultTemplate.message);
      }
    }
  }, [userRoleOptions, selectedOption]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-describedby="alert-dialog-description"
      classes={{ paper: "inherit" }}
      fullScreen={isMobileRes}
      fullWidth={isMobileRes}
      maxWidth="lg"
      PaperProps={{
        sx: {
          height: { xs: "100%", sm: 900 },
          backgroundColor: theme.palette.background.default,
        },
      }}
    >
      <Grid className={isMobileRes ? classes.DialogMobile : classes.Dialog}>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid item pt={2} alignContent={"center"}>
                  {/* <Typography className={classes.cardTitle}>
                    Create Request / Reschedule
                  </Typography> */}
                  <ToggleButtonGroup
                    value={mode}
                    exclusive
                    onChange={(e, value) => value && setMode(value)}
                    size="small"
                    orientation="horizontal"
                    sx={{
                      flexWrap: { xs: "wrap", md: "nowrap" },
                      width: { xs: "100%", md: "auto" },
                      justifyContent: {
                        xs: "flex-start",
                        md: "flex-end",
                      },
                    }}
                  >
                    <ToggleButton
                      value="schedule"
                      color="primary"
                      sx={{
                        textTransform: "none",
                        gap: 1,
                        width: { xs: "100%", md: "auto" },
                      }}
                    >
                      Edit
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Grid>
                <Grid
                  item
                  pt={2}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    variant="contained"
                    className={classes.editButton}
                    onClick={handleClose}
                  >
                    <CloseIcon />
                  </Button>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          {mode === "schedule" && (
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <FormikProvider value={formik}>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={3}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        {/* <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              Schedule Information
                            </Typography>
                          </Grid>
                        </Grid> */}

                        <Grid container spacing={3} p={"24px"}>
                          <Grid item lg={6} md={6} sm={12} xs={12}>
                            <Grid container alignItems="center">
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  Staff{" "}
                                  <span className={classes.requiedfield}>
                                    *
                                  </span>
                                </Typography>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <TextField
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment
                                        position="start"
                                        sx={{ pr: 2 }}
                                      >
                                        <CiSearch
                                          className={classes.searchWidgetIcon}
                                        />
                                      </InputAdornment>
                                    ),
                                  }}
                                  value={searchQueryCustomer}
                                  onChange={handleTextFieldChange}
                                  placeholder="Name & phone number .."
                                  size="small"
                                  onFocus={handleFocusOrClickCustomer}
                                  onClick={handleFocusOrClickCustomer}
                                  sx={{ flexGrow: 1, width: "100%" }}
                                  InputLabelProps={{ shrink: true }}
                                />
                                {showDropdownCustomer && (
                                  <Paper className={classes.dropdownPaper}>
                                    {tenantIsLoading ? (
                                      <div
                                        style={{
                                          textAlign: "center",
                                          padding: "10px",
                                        }}
                                      >
                                        <CircularProgress size={24} />
                                      </div>
                                    ) : (
                                      teamList.length > 0 &&
                                      teamList.map((team) => (
                                        <MenuItem
                                          key={team.id}
                                          onClick={() =>
                                            handleSelectCustomer(team)
                                          }
                                        >
                                          {`${team.teamFirstName || ""} ${
                                            team.teamLastName || ""
                                          }`}
                                        </MenuItem>
                                      ))
                                    )}
                                  </Paper>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item lg={6} md={6} sm={12} xs={12}>
                            <Grid container alignItems="center">
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  Date{" "}
                                  <span className={classes.requiedfield}>
                                    *
                                  </span>
                                </Typography>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DatePicker
                                    value={formik.values.date}
                                    onChange={(date) =>
                                      formik.setFieldValue("date", date)
                                    }
                                    disabled
                                    slotProps={{
                                      textField: {
                                        placeholder: "Schedule Date",
                                        size: "small",
                                        sx: {
                                          width: "100%",
                                        },
                                        InputProps: {
                                          sx: {
                                            fontSize: 14,
                                          },
                                          readOnly: true,
                                        },
                                        InputLabelProps: {
                                          sx: {
                                            fontSize: 14,
                                          },
                                        },
                                      },
                                    }}
                                  />
                                </LocalizationProvider>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item lg={4} md={4} sm={12} xs={12}>
                            <Grid container alignItems="center">
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  Start Time{" "}
                                  <span className={classes.requiedfield}>
                                    *
                                  </span>
                                </Typography>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <TimeDropdown
                                  value={formik.values.startTime}
                                  onChange={(time) =>
                                    formik.setFieldValue(`startTime`, time)
                                  }
                                />
                                {formik.touched.startTime &&
                                  formik.errors.startTime && (
                                    <Typography color="error" fontSize={13}>
                                      {formik.errors.startTime}
                                    </Typography>
                                  )}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item lg={8} md={8} sm={12} xs={12}>
                            <Grid container alignItems="center">
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  End Time{" "}
                                  <span className={classes.requiedfield}>
                                    *
                                  </span>
                                </Typography>
                              </Grid>
                              <Grid item lg={6} md={8} sm={12} xs={12}>
                                <TimeDropdown
                                  value={formik.values.endTime}
                                  onChange={(time) =>
                                    formik.setFieldValue(`endTime`, time)
                                  }
                                />
                                {formik.touched.endTime &&
                                  formik.errors.endTime && (
                                    <Typography color="error" fontSize={13}>
                                      {formik.errors.endTime}
                                    </Typography>
                                  )}
                              </Grid>
                              <Grid item pl={2}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={formik.values.spansNextDay}
                                      onChange={(e) =>
                                        formik.setFieldValue(
                                          "spansNextDay",
                                          e.target.checked
                                        )
                                      }
                                    />
                                  }
                                  label="Ends next day"
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                          {Boolean(formik.values.isCreateSchedule) === true &&
                            Boolean(formik.values.isEditedSchedule) === false &&
                            Boolean(formik.values.isRemovedSchedule) ===
                              false && (
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container alignItems="center">
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={
                                              formik.values.isUpdateForAllDate
                                            }
                                            onChange={(event) => {
                                              formik.setFieldValue(
                                                "isUpdateForAllDate",
                                                event.target.checked
                                              );
                                            }}
                                          />
                                        }
                                        label={
                                          <>
                                            Future Date Updates{" "}
                                            <strong>(Starting Today)</strong>
                                          </>
                                        }
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}

                          {Boolean(formik.values.isEditedSchedule) === true &&
                            Boolean(formik.values.isReSchedules) === false &&
                            Boolean(formik.values.isCreateSchedule) === false &&
                            Boolean(formik.values.isRemovedSchedule) ===
                              false && (
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container alignItems="center">
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={
                                              formik.values.isUpdateForAllDate
                                            }
                                            onChange={(event) => {
                                              formik.setFieldValue(
                                                "isUpdateForAllDate",
                                                event.target.checked
                                              );
                                            }}
                                          />
                                        }
                                        label={
                                          <>
                                            Future Date Updates{" "}
                                            <strong>(Starting Today)</strong>
                                          </>
                                        }
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}

                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              pb: 2,
                            }}
                          >
                            <Button
                              variant="outlined"
                              startIcon={<CloseIcon />}
                              className={classes.addButton}
                              onClick={handleCloseRemovedSetSchedule}
                            >
                              Reset
                            </Button>
                            <Box m={0.5}></Box>

                            <Button
                              variant="contained"
                              startIcon={
                                isLoading ? (
                                  <CircularProgress
                                    size={18}
                                    className={classes.isLoading}
                                  />
                                ) : (
                                  <SaveAltIcon />
                                )
                              }
                              className={classes.addButton}
                              onClick={() => formik.handleSubmit()}
                              disabled={!formValid || isLoading}
                            >
                              {getButtonLabel()}
                            </Button>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    {coursings.length > 0 && (
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Card className={classes.card}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ padding: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              lg={4}
                              md={4}
                              sm={12}
                              xs={12}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              <Grid
                                container
                                spacing={1}
                                justifyContent="flex-start"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  alignContent: "center",
                                }}
                              >
                                <Grid item>
                                  <Typography className={classes.cardTitle}>
                                    Schedule List
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid>
                            <TableContainer>
                              <Table className={classes.table}>
                                <TableHead className={classes.tableHeaderRow}>
                                  <TableRow>
                                    <TableCell className={classes.tablheader}>
                                      <strong>Schedule </strong>
                                    </TableCell>
                                    <TableCell className={classes.tablheader}>
                                      <strong>Status</strong>
                                    </TableCell>
                                    {userHasRight(Privileges.ScheduleEdit) && (
                                      <TableCell
                                        className={classes.tablheader}
                                        sx={{ textAlign: "right" }}
                                      >
                                        <strong>Actions</strong>
                                      </TableCell>
                                    )}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {rescheduleIsLoading ? (
                                    <TableRow>
                                      <TableCell colSpan={20} align="center">
                                        <Box
                                          display="flex"
                                          justifyContent="center"
                                          alignItems="center"
                                          height="10vh"
                                        >
                                          <CircularProgress />
                                        </Box>
                                      </TableCell>
                                    </TableRow>
                                  ) : rescheduleIsError ||
                                    coursings.length === 0 ? (
                                    <TableRow>
                                      <TableCell colSpan={20} align="center">
                                        {rescheduleIsError
                                          ? "Error fetching data"
                                          : "No data available"}
                                      </TableCell>
                                    </TableRow>
                                  ) : (
                                    coursings
                                      .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                      )
                                      .map(
                                        (row: IScheduleListDetails, index) => {
                                          return (
                                            <TableRow
                                              key={index}
                                              className={classes.tableRowHover}
                                            >
                                              <TableCell
                                                scope="row"
                                                className={classes.tablCell}
                                              >
                                                {formatTime(
                                                  row.schedule?.startTime
                                                )}{" "}
                                                -{" "}
                                                {formatTime(
                                                  row.schedule?.endTime
                                                )}{" "}
                                                {row.schedule &&
                                                  row.schedule.spansNextDay ==
                                                    true && (
                                                    <span
                                                      style={{
                                                        color: "#e3791a",
                                                        fontWeight: 600,
                                                        lineHeight: 1.5,
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1px",
                                                      }}
                                                    >
                                                      [next day]
                                                    </span>
                                                  )}
                                                {row.schedule &&
                                                row.schedule
                                                  .schedule_end_date ? (
                                                  row.schedule.status ===
                                                  "deleted" ? (
                                                    <span
                                                      style={{
                                                        color: "#d32f2f",
                                                        fontWeight: 600,
                                                        paddingLeft: "1px",
                                                      }}
                                                    >
                                                      [D]
                                                    </span>
                                                  ) : row.schedule
                                                      .schedule_end_date &&
                                                    row.schedule.status ===
                                                      "updated" ? (
                                                    <span
                                                      style={{
                                                        color: "#1976d2",
                                                        fontWeight: 600,
                                                        paddingLeft: "1px",
                                                      }}
                                                    >
                                                      [Up]
                                                    </span>
                                                  ) : null
                                                ) : null}
                                              </TableCell>
                                              <TableCell
                                                scope="row"
                                                className={classes.tablCell}
                                                // sx={{ textAlign: "center" }}
                                              >
                                                <Grid
                                                  container
                                                  spacing={1}
                                                  // justifyContent={"center"}
                                                >
                                                  <Grid
                                                    item
                                                    lg={12}
                                                    md={12}
                                                    sm={12}
                                                    xs={12}
                                                    sx={{
                                                      display: "flex",
                                                      // justifyContent: "center",
                                                    }}
                                                  >
                                                    <Box
                                                      className={
                                                        row.isReSchedules ===
                                                        false
                                                          ? classes.editButtonStatusWaiting
                                                          : classes.editButtonStatusAvailable
                                                      }
                                                    >
                                                      {row.isReSchedules
                                                        ? "Modified"
                                                        : "Usual"}
                                                    </Box>
                                                  </Grid>
                                                </Grid>
                                              </TableCell>
                                              {userHasRight(
                                                Privileges.ScheduleEdit
                                              ) && (
                                                <TableCell
                                                  scope="row"
                                                  className={classes.tablCell}
                                                >
                                                  {row.schedule &&
                                                  row.schedule
                                                    .schedule_end_date ==
                                                    null ? (
                                                    <Grid
                                                      container
                                                      spacing={1}
                                                      sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "flex-end",
                                                      }}
                                                    >
                                                      <Grid item>
                                                        <Button
                                                          className={
                                                            classes.editButtonList
                                                          }
                                                          onClick={() =>
                                                            handleEditedSchedule(
                                                              row
                                                            )
                                                          }
                                                        >
                                                          <EditSharpIcon
                                                            className={
                                                              classes.editListIcon
                                                            }
                                                          />
                                                        </Button>
                                                      </Grid>
                                                      <Grid item>
                                                        <Button
                                                          className={
                                                            classes.deleteButtonList
                                                          }
                                                          onClick={() =>
                                                            handleRemoveSetSchedule(
                                                              row
                                                            )
                                                          }
                                                        >
                                                          <DeleteOutlineSharpIcon
                                                            className={
                                                              classes.deleteListIcon
                                                            }
                                                          />
                                                        </Button>
                                                      </Grid>
                                                    </Grid>
                                                  ) : (
                                                    <Typography
                                                      textAlign="right"
                                                      sx={{
                                                        color:
                                                          row.schedule
                                                            ?.status ===
                                                          "deleted"
                                                            ? "#d32f2f"
                                                            : row.schedule
                                                                ?.status ===
                                                              "updated"
                                                            ? "#1976d2"
                                                            : "#000",
                                                        fontWeight: 600,
                                                        lineHeight: 1.5,
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1px",
                                                        fontStyle: "italic",
                                                      }}
                                                    >
                                                      {row.schedule
                                                        ?.schedule_end_date && (
                                                        <>
                                                          -- Previous time slot{" "}
                                                          {row.schedule
                                                            .status ===
                                                          "deleted"
                                                            ? "(deleted on "
                                                            : row.schedule
                                                                .status ===
                                                              "updated"
                                                            ? "(updated on "
                                                            : "("}
                                                          {dayjs(
                                                            row.schedule
                                                              .schedule_end_date
                                                          ).format(
                                                            "MMM D, YYYY h:mm A"
                                                          )}
                                                          {")"} --
                                                        </>
                                                      )}
                                                    </Typography>
                                                  )}
                                                </TableCell>
                                              )}
                                            </TableRow>
                                          );
                                        }
                                      )
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                        </Card>
                      </Grid>
                    )}
                  </Grid>
                  <Dialog
                    open={openRemovePopup}
                    onClose={handleCloseRemovedSetSchedule}
                    sx={{ padding: 5, minWidth: 450 }}
                  >
                    <Grid
                      className={
                        isMobileRes ? classes.DialogMobile : classes.Dialog
                      }
                    >
                      <form onSubmit={formik.handleSubmit}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              Remove Schedule Confirmation
                            </Typography>
                          </Grid>
                        </Grid>
                        <DialogContent>
                          <DialogContentText sx={{ pt: 3 }}>
                            Are you sure you want to removed with this schedule?
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            variant="outlined"
                            startIcon={<CloseIcon />}
                            className={classes.addButton}
                            onClick={() => handleCloseRemovedSetSchedule()}
                          >
                            Cancel
                          </Button>
                          <Box m={0.5}></Box>

                          <Button
                            variant="contained"
                            startIcon={
                              isLoading ? (
                                <CircularProgress
                                  size={18}
                                  className={classes.isLoading}
                                />
                              ) : (
                                <DeleteIcon />
                              )
                            }
                            className={classes.addButton}
                            onClick={() => formik.handleSubmit()}
                            disabled={!formValid || isLoading}
                          >
                            Remove
                          </Button>
                        </DialogActions>
                      </form>
                    </Grid>
                  </Dialog>
                </form>
              </FormikProvider>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default Team;
